import { render, staticRenderFns } from "./AddCate.vue?vue&type=template&id=4878cebb&"
import script from "./AddCate.vue?vue&type=script&lang=js&"
export * from "./AddCate.vue?vue&type=script&lang=js&"
import style0 from "./AddCate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports